/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const deleteSettings = () => hmsAPI.delete('/settings/')
export const getSettings = () => hmsAPI.get('/settings/')
export const setSettings = data => hmsAPI.post('/settings/', data)
export const updateSettings = data => hmsAPI.put('/settings/', data)
